<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex>
        <v-row no-gutters>
          <v-col>
            <slot name="dat-instances" />
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class InstancesLayout extends Vue {

}
</script>
